const COUNTRIES_DE = {
  AL: 'Albanien',
  AD: 'Andorra',
  AT: 'Österreich',
  AZ: 'Aserbaidschan',
  BY: 'Belarus',
  BE: 'Belgien',
  BA: 'Bosnien und Herzegowina',
  BG: 'Bulgarien',
  HR: 'Kroatien',
  CY: 'Zypern',
  CZ: 'Tschechische Republik',
  DK: 'Dänemark',
  EE: 'Estland',
  FI: 'Finnland',
  FR: 'Frankreich',
  GE: 'Georgia',
  DE: 'Deutschland',
  GR: 'Griechenland',
  HU: 'Ungarn',
  IS: 'Island',
  IE: 'Irland',
  IT: 'Italien',
  KZ: 'Kasachstan',
  LV: 'Lettland',
  LI: 'Liechtenstein',
  LT: 'Litauen',
  LU: 'Luxemburg',
  MK: 'ehemalige jugoslawische Republik Mazedonien',
  MT: 'Malta',
  MD: 'Republik Moldau',
  MC: 'Monaco',
  ME: 'Montenegro',
  NL: 'Niederlande',
  NO: 'Norwegen',
  PL: 'Polen',
  PT: 'Portugal',
  RO: 'Rumänien',
  RU: 'Russland',
  SM: 'San Marino',
  RS: 'Serbien',
  SK: 'Slowakei',
  SI: 'Slowenien',
  ES: 'Spanien',
  SE: 'Schweden',
  CH: 'Schweiz',
  TR: 'Türkei',
  UA: 'Ukraine',
  GB: 'Großbritannien'
}

export default COUNTRIES_DE



// WEBPACK FOOTER //
// ./src/i18n/de/countries.js